import { UseAppContext } from '../AppContext'

/*
 * Note to developer: As these methods are using a react hook, it can only be called while React is rendering 
 * a function component ie. in the reunder or at the top level in the body of a component
 */

export const isClient = (cId) => {
    const { clientId } = UseAppContext()[0];
    return clientId === cId ? true : false;
}

export const isJwCole = () => {
    const { clientId } = UseAppContext()[0];
    return clientId === "jwcole" ? true : false;
};

export const isAsn = () => {
    const { clientId } = UseAppContext()[0];
    return clientId === "asn" ? true : false;
};

export const isSteward = () => {
    const { clientId } = UseAppContext()[0];
    return clientId.startsWith("steward") ? true : false;
};

export const isLevelFourRaymondJames = () => {
    const { clientId } = UseAppContext()[0];
    return clientId.startsWith("levelfourraymondjames") ? true : false;
};
